import { networkService } from "services/networkService";
import {
  METHOD_CPU_LIST,
  METHOD_CPU_CREATE,
  METHOD_CPU_UPDATE,
  METHOD_CPU_DELETE,
  METHOD_CPU_DETAIL,
} from "constants/admin/masters/cpu";
class CpuService {
  getAll = (data) => {
    return networkService
      .post(METHOD_CPU_LIST, data)
      .then((response) => response.data);
  };
  getDetail = (id) => {
    const updatedMethodName = METHOD_CPU_DETAIL.replace("{ID}", id);
    return networkService
      .get(updatedMethodName)
      .then((response) => response.data);
  };
  create = (data) => {
    return networkService
      .post(METHOD_CPU_CREATE, data)
      .then((response) => response.data);
  };
  update = (data, id) => {
    const updatedMethodName = METHOD_CPU_UPDATE.replace("{ID}", id);
    return networkService
      .post(updatedMethodName, data)
      .then((response) => response.data);
  };
  delete = (id,is_delete=false) => {
    const updatedMethodName = METHOD_CPU_DELETE.replace("{ID}", id);
    return networkService
      .delete(updatedMethodName,{ data: { is_delete }})
      .then((response) => response.data);
  };
}
export default CpuService;
